<div class="toolbar">
    <button
        *ngIf="!!buttons.export"
        matSuffix mat-flat-button
        color="{{buttons.export.color}}"
        aria-label="Download"
        matTooltip="{{buttons.export.tooltip | translate}}"
        (click)="do('export')">
        {{(buttons.export.label ?? '') | translate}}
        <mat-icon>{{buttons.export.icon}}</mat-icon>
    </button>
    <input #files hidden="true" type="file" onclick="this.value = null" (change)="do('import', $event)" [accept]="contentTypes" />
    <button
        *ngIf="!!buttons.import"
        matSuffix mat-flat-button
        color="{{buttons.import.color}}"
        aria-label="Upload"
        matTooltip="{{buttons.import.tooltip | translate}}"
        (click)="files.click()">
        {{(buttons.import.label ?? '') | translate}}
        <mat-icon>{{buttons.import.icon}}</mat-icon>
    </button>
    <button
        *ngIf="!!buttons.add"
        matSuffix mat-flat-button
        color="{{buttons.add.color}}"
        aria-label="Add new"
        matTooltip="{{buttons.add.tooltip | translate}}"
        (click)="do(buttons.add.event)">
        {{(buttons.add.label ?? '') | translate}}
        <mat-icon>add</mat-icon>
    </button>
</div>
<div class="toolbar-mobile">
    <button mat-icon-button color="primary" [matMenuTriggerFor]="menu">
        <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <button
            mat-menu-item
            *ngIf="!!buttons.export"
            aria-label="Download"
            matTooltip="{{buttons.export.tooltip | translate}}"
            (click)="do('export')">
            <mat-icon>{{buttons.export.icon}}</mat-icon>
            {{(buttons.export.label ?? '') | translate}}
        </button>
        <button
            mat-menu-item
            *ngIf="!!buttons.import"
            aria-label="Upload"
            matTooltip="{{buttons.import.tooltip | translate}}"
            (click)="files.click()">
            <mat-icon>{{buttons.import.icon}}</mat-icon>
            {{(buttons.import.label ?? '') | translate}}
        </button>
        <button
            mat-menu-item
            *ngIf="!!buttons.add"
            aria-label="Add new"
            matTooltip="{{buttons.add.tooltip | translate}}"
            (click)="do(buttons.add.event)">
            <mat-icon>add</mat-icon>
            {{(buttons.add.label ?? '') | translate}}
        </button>
    </mat-menu>
</div>
<div class="filter" *ngIf="!!filters?.length">
    <mat-form-field class="form-field">
        <mat-label>{{ 'labels.typeToFilter' | translate }}</mat-label>
        <input matInput type="text" #search>
        <button matSuffix mat-icon-button color="primary" aria-label="Clear" (click)="clear()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
    <ng-container *ngFor="let filter of selectFilters">
        <mat-form-field class="form-field">
            <mat-label>{{filter.label ?? '' | translate}}</mat-label>
            <mat-select [(value)]="filter.value" (valueChange)="load()">
                <mat-option *ngFor="let option of filter.options" [value]="option.value">{{option.label}}</mat-option>
            </mat-select>
        </mat-form-field>
    </ng-container>
</div>
<mmg-custom-filter [filter]="customFilter"></mmg-custom-filter>
<mat-table class="mat-elevation-z8" matSort [dataSource]="dataSource">
    <ng-container *ngFor="let column of availableColumns">
        <ng-container matColumnDef="{{column.name}}">
            <ng-container *ngIf="column.name !== 'actions'; else elseBlock">
                <mat-header-cell *matHeaderCellDef mat-sort-header>{{column.description | translate}}</mat-header-cell>
                <ng-container [ngSwitch]="column.type">
                    <ng-container *ngSwitchCase="'date'">
                        <mat-cell *matCellDef="let item">{{item[column.name] | date:'dd-MM-yyyy'}}</mat-cell>
                    </ng-container>
                    <ng-container *ngSwitchCase="'icon'">
                        <mat-cell *matCellDef="let item"><span [innerHtml]="item[column.name]"></span></mat-cell>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <mat-cell *matCellDef="let item">{{item[column.name]}}</mat-cell>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-template #elseBlock>
                <mat-header-cell *matHeaderCellDef>{{column.description | translate}}</mat-header-cell>
                <mat-cell *matCellDef="let item">
                    <div *ngIf="!isMobile; else mobileActions">
                        <ng-container *ngFor="let action of listActions">
                            <button mat-icon-button color="{{action.color}}" matTooltip="{{action.tooltip | translate}}" (click)="do(action.event, item)">
                                <mat-icon>{{action.icon}}</mat-icon>
                            </button>
                        </ng-container>
                    </div>
                    <ng-template #mobileActions>
                        <button mat-icon-button color="primary" [matMenuTriggerFor]="menuActions">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menuActions="matMenu">
                            <button *ngFor="let action of listActions"
                                mat-menu-item
                                matTooltip="{{action.tooltip | translate}}"
                                (click)="do(action.event, item)">
                                <mat-icon>{{action.icon}}</mat-icon>
                                {{action.tooltip | translate}}
                            </button>
                        </mat-menu>
                    </ng-template>
                </mat-cell>
            </ng-template>
        </ng-container>
    </ng-container>
    <mat-header-row *matHeaderRowDef="headers"></mat-header-row>
    <mat-row *matRowDef="let row; columns: headers"></mat-row>
</mat-table>
<mat-paginator [length]="dataSource.count" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 50]"></mat-paginator>